import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Yoga Teacher — London, United Kingdom',
  text: '"I no longer spend my Sunday nights building sequences from scratch. I open the library, choose the class, and I walk in completely prepared. My students feel the difference — and so do I."'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Yoga Instructor — Toronto, Canada',
  text: '"The emergency classes alone saved me three times in the first month. That bonus is worth the entire price on its own."'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Yoga Teacher — Sydney, Australia',
  text: '"The cueing library changed how I teach completely. My transitions feel smoother, my language is clearer, and my students stay focused from the first breath to the final relaxation."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-dark-card border-y border-dark-border" data-id="element-269">
      <div className="max-w-7xl mx-auto px-4" data-id="element-270">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-271">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-black border border-gold/20 p-6 rounded-2xl relative" data-id="element-272">
              <div className="flex gap-1 text-gold mb-4" data-id="element-273">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-274" />)}
              </div>
              <p className="text-gray-300 italic mb-6 text-sm leading-relaxed" data-id="element-275">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-276">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center text-gold font-bold" data-id="element-277">
                  {t.initials}
                </div>
                <div data-id="element-278">
                  <div className="font-bold text-white text-sm" data-id="element-279">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-280">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}